import { useState, useEffect } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const useTvgallery = () => {
  const [tvGalleryItems, setTvGalleryItems] = useState([]);

  const getCarouselData = async () => {
    try {
      const res = await getApi(apiEndPoints?.get_tvgallery_events);
      const res1 = await getApi(apiEndPoints?.getAllNewsForTvGallery);

      // Concatenate the data from both responses
      const combinedData = [
        ...(res?.data?.data || []),
        ...(res1?.data?.data || []),
      ];

      // Set the combined data to state
      setTvGalleryItems(combinedData);
    } catch (error) {
      console.error("Error fetching TV gallery data:", error);
    }
  };

  useEffect(() => {
    getCarouselData();
  }, []);

  return {tvGalleryItems};
};

export default useTvgallery;